<template>
  <RalanCard :ralan="ralan" v-if="loaded" />
</template>
<style>
@page {
  size: A4 landscape;
}
</style>
<script>
// @ is an alias to /src

import RalanCard from "@/components/RalanCard.vue";

export default {
  name: "RalanCetakKartu",
  components: {
    RalanCard,
  },
  data: function() {
    return { fromUrl: "", plainUrl: "", ralan: null, loaded: false };
  },
  methods: {
    activateTab(tab) {
      this.tabActive = tab.link;
      this.tabs = this.tabs.map((item) => {
        if (item.active) {
          item.active = false;
        }
        if (tab.link == item.link) {
          item.active = true;
        }
        return item;
      });
    },
    displayData: async function() {
      this.loaded = false;
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/${this.$route.params.id}`
        );
        this.ralan = result.data;
        let self = this;
        if (result.status == "200") {
          this.loaded = true;
          //console.log(result);
          setTimeout(() => {
            window.print();
            // window.open('', '_parent', '');
            // window.close();
          }, 500);
          window.onafterprint = function() {
            // self.$router.push(
            //   `${parseInt(self.ralan.darurat) ? "/ugd/" : "/ralan/"}detail/${
            //     self.ralan.id
            //   }`
            // );
            self.$router.push(
              `${parseInt(self.ralan.darurat) ? "/ugd/" : "/ralan/"}`
            );
          };
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
  },

  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.displayData();
  },
};
</script>
